import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Grid.module.scss';
import alignStyles from './styles/Align.module.scss';
import directionStyles from './styles/Direction.module.scss';
import gapStyles from './styles/Gap.module.scss';
import justifyStyles from './styles/Justify.module.scss';
import templateStyles from './styles/Template.module.scss';

export const Grid = (props: Props) => (
    <div className={classes(props)}>
        {props.children}
    </div>
);

export type GridGapSizes = 'xs' | 's' | 'm' | 'l';

type Props = PropsWithChildren<{
    direction?: 'column' | 'row';
    gap?: GridGapSizes;
    justify?: 'start' | 'center' | 'end' | 'around' | 'evenly' | 'between';
    align?: 'start' | 'center' | 'end' | 'stretch';
    wrap?: boolean;
    fullHeight?: boolean;
    fullWidth?: boolean;
    className?: string;
} & GridLayout>;

type Fraction = 'full' | '1/2' | '1/3' | '1/4' | '1/5' | '1/6';
type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type GridLayout = {
    [Key in Breakpoint]?: Fraction
};

const classes = ({
    className,
    fullHeight, fullWidth,
    gap, direction, wrap,
    justify, align,
    ...template
}: Props) => {

    return classNames(className, styles.default, {

        ...mapStyle(directionStyles, direction),
        ...mapStyle(justifyStyles, justify),
        ...mapStyle(alignStyles, align),
        ...mapStyle(gapStyles, gap),

        [styles.wrap]: wrap,

        [styles.fullHeight]: fullHeight,
        [gapStyles.fullHeight]: fullHeight,

        [styles.fullWidth]: fullWidth,
        [gapStyles.fullWidth]: fullWidth,

        ...mapPrefixedStyle(templateStyles, 'template-', template.xs),
        ...mapPrefixedStyle(templateStyles, 'sm:template-', template.sm),
        ...mapPrefixedStyle(templateStyles, 'md:template-', template.md),
        ...mapPrefixedStyle(templateStyles, 'lg:template-', template.lg),
        ...mapPrefixedStyle(templateStyles, 'xl:template-', template.xl)
    });
};

const mapStyle = (styles: Record<string, string>, key: string | undefined) => {
    return key !== undefined
        ? { [styles[key]]: true }
        : undefined;
};

const mapPrefixedStyle = (styles: Record<string, string>, prefix: string, key: string | undefined) => {
    return key !== undefined
        ? { [styles[prefix + key]]: true }
        : undefined;
};